var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconBuild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_218",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2399",
    "data-name": "Group 2399",
    transform: "translate(-448 -1253)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 448, 1253)",
    filter: "url(#Ellipse_218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_218-2",
    "data-name": "Ellipse 218",
    transform: "translate(9 6)",
    fill: "#7ab53f",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "building",
    transform: "translate(472.04 1274.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M131.028,477.867H119.866a.4.4,0,0,0-.4.4v.8a.4.4,0,0,0,.8,0v-.4h10.764a.4.4,0,0,0,0-.8Z",
    transform: "translate(-113.886 -455.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M187.733,156.391a.4.4,0,0,0,.4.4h1.595a.4.4,0,0,0,.4-.4V154a.4.4,0,0,0-.4-.4h-1.595a.4.4,0,0,0-.4.4v2.392Zm.8-1.993h.8v1.595h-.8Z",
    transform: "translate(-178.962 -146.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M5.183,102.4H.4a.4.4,0,0,0-.4.4v7.973a.4.4,0,1,0,.8,0V103.2H5.183a.4.4,0,0,0,0-.8Z",
    transform: "translate(0 -97.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M409.6,361.191a.4.4,0,0,0,.4.4h1.595a.4.4,0,0,0,.4-.4V358.8a.4.4,0,0,0-.4-.4H410a.4.4,0,0,0-.4.4Zm.8-1.993h.8v1.595h-.8Z",
    transform: "translate(-390.464 -341.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M1.993,307.2C.023,307.2,0,312.331,0,312.383a2,2,0,0,0,1.595,1.953v2.034a.4.4,0,0,0,.8,0v-2.034a2,2,0,0,0,1.595-1.953C3.987,312.331,3.964,307.2,1.993,307.2Zm0,6.379a1.2,1.2,0,0,1-1.2-1.2c0-1.986.533-4.385,1.2-4.385s1.2,2.4,1.2,4.385A1.2,1.2,0,0,1,1.993,313.579Z",
    transform: "translate(0 -292.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M53.193,256H51.6a.4.4,0,0,0-.4.4v.8a.4.4,0,1,0,.8,0v-.4h.8v1.993a.4.4,0,0,0,.8,0V256.4A.4.4,0,0,0,53.193,256Z",
    transform: "translate(-48.808 -244.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M410,156.79h1.595a.4.4,0,0,0,.4-.4V154a.4.4,0,0,0-.4-.4H410a.4.4,0,0,0-.4.4v2.392A.4.4,0,0,0,410,156.79Zm.4-2.392h.8v1.595h-.8Z",
    transform: "translate(-390.464 -146.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M53.193,153.6H51.6a.4.4,0,0,0-.4.4v2.392a.4.4,0,0,0,.4.4h1.595a.4.4,0,0,0,.4-.4V154A.4.4,0,0,0,53.193,153.6Zm-.4,2.392H52V154.4h.8v1.595Z",
    transform: "translate(-48.808 -146.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M273.067,156.391a.4.4,0,0,0,.4.4h1.595a.4.4,0,0,0,.4-.4V154a.4.4,0,0,0-.4-.4h-1.595a.4.4,0,0,0-.4.4Zm.8-1.993h.8v1.595h-.8Z",
    transform: "translate(-260.309 -146.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M397.717,102.4h-4.784a.4.4,0,0,0,0,.8h4.385v16.02a1.139,1.139,0,0,0-.6-.055,1.592,1.592,0,0,0-2.78,0,1.172,1.172,0,0,0-.2-.018,1.2,1.2,0,0,0,0,2.392h3.189a1.2,1.2,0,0,0,1.2-1.2V102.8A.4.4,0,0,0,397.717,102.4Zm-.8,18.339H393.73a.4.4,0,0,1,0-.8.394.394,0,0,1,.216.065.4.4,0,0,0,.6-.245.794.794,0,0,1,1.548,0,.4.4,0,0,0,.6.245.407.407,0,0,1,.615.334A.4.4,0,0,1,396.919,120.739Z",
    transform: "translate(-374.195 -97.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M273.466,54.39h1.595a.4.4,0,0,0,.4-.4V51.6a.4.4,0,0,0-.4-.4h-1.595a.4.4,0,0,0-.4.4v2.392A.4.4,0,0,0,273.466,54.39Zm.4-2.392h.8v1.595h-.8Z",
    transform: "translate(-260.309 -48.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M273.067,258.791a.4.4,0,0,0,.4.4h1.595a.4.4,0,0,0,.4-.4V256.4a.4.4,0,0,0-.4-.4h-1.595a.4.4,0,0,0-.4.4Zm.8-1.993h.8v1.595h-.8Z",
    transform: "translate(-260.309 -244.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M188.133,54.39h1.595a.4.4,0,0,0,.4-.4V51.6a.4.4,0,0,0-.4-.4h-1.595a.4.4,0,0,0-.4.4v2.392A.4.4,0,0,0,188.133,54.39Zm.4-2.392h.8v1.595h-.8Z",
    transform: "translate(-178.963 -48.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M247.582,409.817a.4.4,0,1,0,.566,0A.419.419,0,0,0,247.582,409.817Z",
    transform: "translate(-235.904 -390.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M187.733,258.791a.4.4,0,0,0,.4.4h1.595a.4.4,0,0,0,.4-.4V256.4a.4.4,0,0,0-.4-.4h-1.595a.4.4,0,0,0-.4.4v2.392Zm.8-1.993h.8v1.595h-.8Z",
    transform: "translate(-178.962 -244.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M170.667,358.8a.4.4,0,0,0,.4.4h1.2v3.588a.4.4,0,0,0,.8,0V359.2h3.189v3.588a.4.4,0,0,0,.8,0V359.2h1.2a.4.4,0,1,0,0-.8h-7.176A.4.4,0,0,0,170.667,358.8Z",
    transform: "translate(-162.694 -341.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M409.6,258.791a.4.4,0,0,0,.4.4h1.595a.4.4,0,0,0,.4-.4V256.4a.4.4,0,0,0-.4-.4H410a.4.4,0,0,0-.4.4Zm.8-1.993h.8v1.595h-.8Z",
    transform: "translate(-390.464 -244.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M147.3,0H136.933a.4.4,0,0,0-.4.4V21.13a.4.4,0,0,0,.8,0V.8H146.9V21.13a.4.4,0,0,0,.8,0V.4A.4.4,0,0,0,147.3,0Z",
    transform: "translate(-130.155)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBuild);
export default __webpack_public_path__ + "static/media/info-icon-build.95f445399b68c0b2b2572964efa73087.svg";
export { ForwardRef as ReactComponent };